"use client"
import useInitMarketingContext from "@/hooks/useInitMarketingContext"
import useEngagementMetrics from "@/hooks/useEngagementMetrics"

export default function MarketingInitClient() {
  useInitMarketingContext()
  useEngagementMetrics()
  return null
}